import celular from '../../../assets/imgs/celularConectai_app.webp'
import appleQR from '../../../assets/imgs/AppleStoreQR.webp'
import googleQR from '../../../assets/imgs/GooglePlayQR.webp'
import { Heading } from '../../ui/Heading'
import { motion } from 'framer-motion'
import { Section } from '../../ui/Section'
import { Apple, Play, Smartphone } from 'lucide-react'
import { SectionTitle } from '../../ui/SectionTitle'

export function Conectai() {
	return (
		<Section className="overflow-hidden border-border-default dark:border-white/5">
			<SectionTitle
				title="Simplifique sua Vida"
				icon={<Smartphone className="text-secondary" size={24} />}
			/>
			<div className="flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-24">

				{/* Phone Image with Floating Animation */}
				<motion.div
					initial={{ opacity: 0, x: -50 }}
					whileInView={{ opacity: 1, x: 0 }}
					viewport={{ once: true, amount: 0.2 }}
					transition={{ duration: 0.8 }}
					className="w-full lg:w-1/2 flex justify-center lg:justify-end"
				>
					<motion.div
						animate={{ y: [0, -20, 0] }}
						transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
					>
						<img
							src={celular}
							className="w-[220px] lg:w-[360px] mx-auto lg:mr-8 transition-transform duration-500 hover:scale-105"
							alt="Conecta.i App"
						/>
					</motion.div>
				</motion.div>

				{/* Content Panel */}
				<motion.div
					initial={{ opacity: 0, x: 50 }}
					whileInView={{ opacity: 1, x: 0 }}
					viewport={{ once: true, amount: 0.2 }}
					className="w-full lg:w-1/2 flex flex-col items-center lg:items-start text-center lg:text-left"
				>


					<Heading level={2} className="text-4xl lg:text-6xl mb-6 text-primary dark:text-on-surface-dark leading-tight font-black">
						Baixe o App <br />
						<span className="text-secondary-dark">Conecta.í</span>
					</Heading>

					<p className="text-on-surface-subtle dark:text-on-surface-dark-muted text-base lg:text-xl mb-12 max-w-md leading-relaxed">
						Todos os serviços da Prefeitura na palma da sua mão. Mais agilidade, transparência e facilidade para você.
					</p>

					<div className="flex flex-wrap items-center justify-center lg:justify-start gap-12 w-full">
						{/* iOS */}
						<div className="flex flex-col items-center gap-5">
							<div className="hidden lg:block p-4 bg-white dark:bg-white/95 rounded-2xl border-2 border-border-default dark:border-transparent transition-all duration-300">
								<img src={appleQR} className="w-24 h-24 lg:w-28 lg:h-28" alt="QR Code App Store" />
							</div>
							<a
								href='https://apps.apple.com/br/app/conecta-%C3%AD/id1315730380'
								target='_blank'
								rel="noreferrer"
								className="flex items-center gap-2 px-5 py-3 bg-black text-white rounded-xl font-bold text-[10px] uppercase tracking-wider hover:bg-zinc-800 transition-colors border-none cursor-pointer"
							>
								<Apple size={16} fill="white" />
								Baixe na Apple Store
							</a>
						</div>

						{/* Android */}
						<div className="flex flex-col items-center gap-5">
							<div className="hidden lg:block p-4 bg-white dark:bg-white/95 rounded-2xl border-2 border-border-default dark:border-transparent transition-all duration-300">
								<img src={googleQR} className="w-24 h-24 lg:w-28 lg:h-28" alt="QR Code Google Play" />
							</div>
							<a
								href='https://play.google.com/store/apps/details?id=br.gov.sc.itajai.digital.conectai'
								target='_blank'
								rel="noreferrer"
								className="flex items-center gap-2 px-5 py-3 bg-black text-white rounded-xl font-bold text-[10px] uppercase tracking-wider hover:bg-zinc-800 transition-colors border-none cursor-pointer"
							>
								<Play size={16} fill="white" className="text-white" />
								Baixe na Google Play
							</a>
						</div>
					</div>


				</motion.div>

			</div>
		</Section>
	)
}